<template>
  <div class="p-company-settings-developer">
    <VPlanPermissionBlocker
      v-if="!$store.getters['plan/permissions'].api"
      ec="developer"
      :planSize="$t('companyPermissionWarning.smallPlan')"
      blockedFeature="companyPermissionWarning.api" />
    <div v-else>
      <template>
        <DeveloperDefaultSharingPermissions />
        <hr class="p-company-settings-developer__hr" />
      </template>
      <DeveloperApiKeys />
      <hr class="p-company-settings-developer__hr" />
      <DeveloperWebhooks />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VPlanPermissionBlocker from '@/views/components/PlanPermissionBlocker.vue';
import DeveloperApiKeys from '@/views/company-settings/DeveloperApiKeys.vue';
import DeveloperWebhooks from '@/views/company-settings/DeveloperWebhooks.vue';
import DeveloperDefaultSharingPermissions from '@/views/company-settings/DeveloperDefaultSharingPermissions.vue';

export default {
  name: 'DeveloperView',
  computed: {
    ...mapGetters({
    }),
  },
  components: {
    DeveloperApiKeys,
    DeveloperWebhooks,
    DeveloperDefaultSharingPermissions,
    VPlanPermissionBlocker,
  },
};
</script>

<style scoped>
.p-company-settings-developer__hr {
  margin: 60px 0 50px 0;
}
</style>
